export default {
  getActiveProfileName: (store) => store.profile?.name,
}
